import { useApiTradeV1TradeCompaniesRetrieve } from '../../client/api/api';
import { useCurrentUser } from '../useCurrentUser/useCurrentUser';

export const useCurrentUserTradeCompany = () => {
  const user = useCurrentUser();
  const tradeCompany = useApiTradeV1TradeCompaniesRetrieve(user.data?.company?.trade_company.id || 0, {
    query: {
      enabled: Boolean(user.data?.company?.trade_company.id),
    },
  });

  return {
    isLoading: tradeCompany.isLoading || user.isLoading,
    tradeCompany,
    user,
  };
};
